<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <router-link to="./common">学生跟进</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>学生评估</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 主体内容 -->
    <div class="content" style="margin-top:20px;">
      <el-form label-position="right" label-width="100px" size="small" :model="form" ref="form">
        <el-tabs>
          <el-tab-pane label="基本信息">
            <!-- 基本信息 -->
            <el-card class="box-card" shadow="hover">
              <div slot="header" class="clearfix">
                <span>基本信息</span>
              </div>

              <el-row>
                <el-col :span="8">
                  <el-form-item
                    label="申请学校"
                    prop="applySchID"
                    :rules="[{required:true,message:'不能空'}]"
                  >
                    <el-select v-model="form.applySchID" filterable placeholder="请选择" style="width:100%;">
                      <el-option label="请选择" value=""></el-option>
                      <el-option
                        v-for="item in schoollist"
                        :label="item.label"
                        :value="item.value"
                        :key="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item
                    label="入学时间"
                    prop="abroadDate"
                    :rules="[{required:true,message:'不能空'}]"
                  >
                    <el-input v-model="form.abroadDate" readonly></el-input>
                    <el-button
                      style="position:absolute;margin-left:-56px;height:30px;top:2px;"
                      @click="abroadTimeDialog=true"
                    >选择</el-button>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="8">
                  <el-form-item
                    label="姓名"
                    prop="realName"
                    :rules="[{required:true,message:'不能为空'}]"
                  >
                    <el-input v-model="form.realName"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="来源" prop="origin" :rules="[{required:true,message:'不能为空'}]">
                    <el-select v-model="form.origin" placeholder="请选择" style="width:100%;">
                      <el-option
                        v-for="item in sourselist"
                        :key="item.name"
                        :label="item.id"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="8">
                  <el-form-item label="民族" prop="nation" :rules="[{required:true,message:'不能为空'}]">
                    <el-select v-model="form.nation" placeholder="请选择" style="width:100%;">
                      <el-option
                        v-for="item in nationlist"
                        :key="item.name"
                        :label="item.id"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label="出生日期"
                    prop="birthday"
                    :rules="[{required:true,message:'不能为空'}]"
                  >
                    <el-date-picker
                      v-model="form.birthday"
                      value-format="yyyy-MM-dd"
                      type="date"
                      placeholder="选择日期"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="婚否" prop="isMarry">
                    <el-switch v-model="form.isMarry"></el-switch>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="8">
                  <el-form-item label="赴日历史" :rules="[{required:false,message:'不能为空'}]">
                    <el-tooltip content="其他申请历史（例如：探亲，工作签证，三年多次往返等请告知）" placement="top">
                      <el-input
                        v-model="form.japanHistory"
                        placeholder="其他申请历史（例如：探亲，工作签证，三年多次往返等请告知）"
                      ></el-input>
                    </el-tooltip>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item label="户籍" :rules="[{required:true,message:'不能为空'}]">
                    <el-select
                      v-model="form.hjProvinceName"
                      prop="hjProvinceName"
                      @change="selectcity"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in provincelist"
                        :label="item.areaName"
                        :value="item.areaName"
                        :key="item.areaID"
                      ></el-option>
                    </el-select>
                    <el-select
                      v-model="form.hjCityName"
                      prop="hjCityName"
                      placeholder="请选择"
                      style="margin-left:20px;"
                    >
                      <el-option
                        v-for="item in citylist"
                        :label="item.areaName"
                        :value="item.areaName"
                        :key="item.areaID"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="8">
                  <el-form-item label="高考成绩" prop="gaoKaoScore">
                    <el-input v-model.number="form.gaoKaoScore"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label="会考成绩"
                    prop="huiKaoScore"
                    :rules="[{type:'number',message:'请输入数字'}]"
                  >
                    <el-input v-model="form.huiKaoScore"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- <el-row>
                <el-col :span="8">
                  <el-form-item label="家庭住址" :rules="[{required:true,message:'不能为空'}]">
                    <el-cascader :options="areaList" v-model="selectedOptions"></el-cascader>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item
                    label="详细地址"
                    prop="siteDetail"
                    :rules="[{required:true,message:'不能为空'}]"
                  >
                    <el-input v-model="form.siteDetail"></el-input>
                  </el-form-item>
                </el-col>
              </el-row> -->

              <el-row>
                 <el-col :span="8">
                  <el-form-item label="学历" prop="eduBack" :rules="[{required:true,message:'不能为空'}]">
                    <el-select v-model="form.eduBack" placeholder="请选择" style="width:100%;">
                      <el-option
                        v-for="item in edubacklist"
                        :key="item.name"
                        :label="item.id"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="现住址" :rules="[{required:true,message:'不能为空'}]">
                    <el-cascader
                      :options="areaList"
                      v-model="selectedOptions2"
                      :props="{value:'label',label:'label'}"
                    ></el-cascader>
                  </el-form-item>
                </el-col>
                <!-- <el-col :span="16">
                  <el-form-item
                    label="详细地址"
                    prop="zzDetail"
                    :rules="[{required:true,message:'不能为空'}]"
                  >
                    <el-input v-model="form.zzDetail"></el-input>
                  </el-form-item>
                </el-col> -->
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="电话" prop="mobile" :rules="[{required:true,message:'不能为空'}]">
                    <el-input v-model="form.mobile"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="QQ" prop="qq">
                    <el-input v-model="form.qq"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="微信" prop="wechat" :rules="[{required:true,message:'不能为空'}]">
                    <el-input v-model="form.wechat"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="8">
                  <el-form-item label="邮箱" prop="email">
                    <el-input v-model="form.email"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label="赴日目地"
                    prop="purpose"
                    :rules="[{required:true,message:'不能为空'}]"
                  >
                    <el-select v-model="form.purpose" placeholder="请选择" style="width:100%;">
                      <el-option
                        v-for="item in purposelist"
                        :key="item.name"
                        :label="item.id"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-card>

            <!-- 日语能力 -->
            <el-card class="box-card table" shadow="hover">
              <div slot="header" class="clearfix">
                <span>日语能力</span>
              </div>

              <el-row>
                <el-col :span="8">
                  <el-form-item
                    label="日语能力"
                    prop="japanese"
                    :rules="[{required:false,message:''}]"
                  >
                 <el-input v-model="form.japanese" aria-placeholder="有证书请填写"></el-input>
                  </el-form-item>
                </el-col>
                <!-- <el-col :span="8">
                  <el-form-item
                    label="JTest考试"
                    prop="jtest"
                    :rules="[{required:true,message:'不能为空'}]"
                  >
                    <el-select v-model="form.jtest" placeholder="请选择" style="width:100%;">
                      <el-option
                        v-for="item in jtestList"
                        :key="item.name"
                        :label="item.id"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col> -->
              </el-row>

              <el-row>
                <el-col :span="8">
                  <el-form-item label="学习机构" prop="learningInstituion">
                    <el-input v-model="form.learningInstituion"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="学习时间">
                    <el-col :span="11">
                      <el-date-picker
                        type="month"
                        value-format="yyyy-MM"
                        placeholder="选择日期"
                        v-model="form.lastExamStartDate"
                        style="width: 100%;"
                      ></el-date-picker>
                    </el-col>
                    <el-col class="line" :span="2" style="text-align:center;">-</el-col>
                    <el-col :span="11">
                      <el-date-picker
                        type="month"
                        value-format="yyyy-MM"
                        placeholder="选择日期"
                        v-model="form.lastExamEndDate"
                        style="width: 100%;"
                      ></el-date-picker>
                    </el-col>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-card>
          </el-tab-pane>
          <el-tab-pane name="edu" label="学历/职历">
            <!-- 学历 -->
            <el-card class="box-card table" shadow="hover">
              <div slot="header" class="clearfix">
                <span>学历</span>
                <el-button
                  @click="dialogVisible1=true;form1={};"
                  style="float: right; padding: 3px 0"
                  type="text"
                >添加</el-button>
              </div>
              <!-- 列表定义 -->
              <el-table v-loading="loading" :data="form.eduList" stripe style="width:100%;">
                <el-table-column prop="name" label="学历名称"></el-table-column>
                <el-table-column prop="school" label="学校名称"></el-table-column>
                <el-table-column prop="startDate" label="开始时间"></el-table-column>
                <el-table-column prop="endDate" label="结束时间"></el-table-column>
                <el-table-column prop="xueZhi" label="学制"></el-table-column>
                <el-table-column prop="special" label="专业"></el-table-column>

                <el-table-column label="操作" width="80" fixed="right">
                  <template slot-scope="scope">
                    <el-button-group>
                      <el-tooltip content="编辑" placement="top">
                        <el-button
                          type="primary"
                          size="mini"
                          icon="el-icon-edit"
                          @click="editClick('form1',scope.row)"
                        ></el-button>
                      </el-tooltip>
                      <el-tooltip content="删除" placement="top">
                        <el-button
                          type="warning"
                          size="mini"
                          icon="el-icon-delete"
                          @click="delClick('form1',scope.row)"
                        ></el-button>
                      </el-tooltip>
                    </el-button-group>
                  </template>
                </el-table-column>
              </el-table>
            </el-card>
            <!-- 职历 -->
            <el-card class="box-card table" shadow="hover">
              <div slot="header" class="clearfix">
                <span>职历</span>
                <el-button
                  style="float: right; padding: 3px 0"
                  type="text"
                  @click="dialogVisible2=true;form2={};"
                >添加</el-button>
              </div>

              <!-- 列表定义 -->
              <el-table v-loading="loading" :data="form.postList" stripe style="width:100%;">
                <el-table-column prop="company" label="单位名称"></el-table-column>
                <el-table-column prop="post" label="职位名称"></el-table-column>
                <el-table-column prop="startDate" label="开始时间"></el-table-column>
                <el-table-column prop="endDate" label="结束时间"></el-table-column>

                <el-table-column label="操作" width="80" fixed="right">
                  <template slot-scope="scope">
                    <el-button-group>
                      <el-tooltip content="编辑" placement="top">
                        <el-button
                          type="primary"
                          size="mini"
                          icon="el-icon-edit"
                          @click="editClick('form2',scope.row)"
                        ></el-button>
                      </el-tooltip>
                      <el-tooltip content="删除" placement="top">
                        <el-button
                          type="warning"
                          size="mini"
                          icon="el-icon-delete"
                          @click="delClick('form2',scope.row)"
                        ></el-button>
                      </el-tooltip>
                    </el-button-group>
                  </template>
                </el-table-column>
              </el-table>
            </el-card>

            <!-- 家庭成员 -->
            <el-card class="box-card table" shadow="hover">
              <div slot="header" class="clearfix">
                <span>家庭成员</span>
                <el-button
                  style="float: right; padding: 3px 0"
                  type="text"
                  @click="dialogVisible3=true;form3={};"
                >添加</el-button>
              </div>

              <!-- 列表定义 -->
              <el-table v-loading="loading" :data="form.familyList" stripe style="width:100%;">
                <el-table-column prop="name" label="姓名"></el-table-column>
                <el-table-column prop="relation" label="关系"></el-table-column>
                <el-table-column prop="post" label="单位和职位名称"></el-table-column>
                <el-table-column prop="income" label="收入"></el-table-column>
                <el-table-column prop="mobile" label="电话"></el-table-column>

                <el-table-column label="操作" width="80" fixed="right">
                  <template slot-scope="scope">
                    <el-button-group>
                      <el-tooltip content="编辑" placement="top">
                        <el-button
                          type="primary"
                          size="mini"
                          icon="el-icon-edit"
                          @click="editClick('form3',scope.row)"
                        ></el-button>
                      </el-tooltip>
                      <el-tooltip content="删除" placement="top">
                        <el-button
                          type="warning"
                          size="mini"
                          icon="el-icon-delete"
                          @click="delClick('form3',scope.row)"
                        ></el-button>
                      </el-tooltip>
                    </el-button-group>
                  </template>
                </el-table-column>
              </el-table>
            </el-card>
          </el-tab-pane>
        </el-tabs>

        <div
          style="margin-top:20px;text-align:right;margin-bottom:40px;background-color:#ddd;padding:15px 25px;"
        >
          <el-button @click="goBack();">返回</el-button>
          <el-button type="primary" @click="submitForm('form')">确定保存</el-button>
        </div>
      </el-form>
    </div>

    <!-- 操作对话框 -->
    <!-- 学历 -->
    <el-dialog :title="form1.id>0?'编辑学历详情':'添加学历详情'" :visible.sync="dialogVisible1">
      <el-form
        :model="form1"
        ref="form1"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm('form1')"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="学历名称" prop="name" :rules="[{required:true,message:'请输入学历名称'}]">
              <el-select v-model="form1.name" placeholder="请选择学历名称" filterable style="width:100%;">
                <el-option
                  v-for="item in edubacklist"
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="学校名称" prop="school" :rules="[{required:true,message:'请输入学校名称'}]">
          <el-input v-model="form1.school" placeholder="请输入学校名称"></el-input>
        </el-form-item>

        <el-form-item label="开始时间" prop="startDate" :rules="[{required:true,message:'请选择时间'}]">
          <el-date-picker
            v-model="form1.startDate"
            value-format="yyyy-MM"
            type="month"
            placeholder="请选择开始时间"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="结束时间" prop="endDate" :rules="[{required:true,message:'请选择时间'}]">
          <el-date-picker
            v-model="form1.endDate"
            value-format="yyyy-MM"
            type="month"
            placeholder="请选择结束时间"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="学制" prop="xueZhi">
          <el-input v-model="form1.xueZhi" placeholder="请输入学制"></el-input>
        </el-form-item>

        <el-form-item label="专业" prop="special">
          <el-input v-model="form1.special" placeholder="请输入专业"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitDialog('form1');">提交</el-button>
        <el-button @click="dialogVisible1=false">取消</el-button>
      </span>
    </el-dialog>

    <!-- 职历 -->
    <el-dialog :title="form2.id>0?'编辑职历详情':'添加职历详情'" :visible.sync="dialogVisible2">
      <el-form
        :model="form2"
        ref="form2"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm('form2')"
      >
        <el-form-item label="单位名称" prop="company" :rules="[{required:true,message:'请输入单位名称'}]">
          <el-input v-model="form2.company" placeholder="请输入单位名称"></el-input>
        </el-form-item>

        <el-form-item label="职位名称" prop="post" :rules="[{required:true,message:'请输入职位名称'}]">
          <el-input v-model="form2.post" placeholder="请输入职位名称"></el-input>
        </el-form-item>

        <el-form-item label="开始时间" prop="startDate" :rules="[{required:true,message:'请选择时间'}]">
          <el-date-picker
            v-model="form2.startDate"
            value-format="yyyy-MM"
            type="month"
            placeholder="请选择开始时间"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="结束时间" prop="endDate" :rules="[{required:true,message:'请选择时间'}]">
          <el-date-picker
            v-model="form2.endDate"
            value-format="yyyy-MM"
            type="month"
            placeholder="请选择结束时间"
          ></el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitDialog('form2');">提交</el-button>
          <el-button @click="dialogVisible2=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 家庭成员 -->
    <el-dialog :title="form3.id>0?'编辑家庭成员':'添加家庭成员'" :visible.sync="dialogVisible3">
      <el-form
        :model="form3"
        ref="form3"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm('form3')"
      >
        <el-form-item label="姓名" prop="name" :rules="[{required:true,message:'请输入姓名'}]">
          <el-input v-model="form3.name" placeholder="请输入姓名"></el-input>
        </el-form-item>

        <el-form-item label="关系" prop="relation" :rules="[{required:true,message:'请输入关系'}]">
          <el-input v-model="form3.relation" placeholder="请输入关系"></el-input>
        </el-form-item>

        <el-form-item label="单位和职位" prop="post" :rules="[{required:true,message:'请输入单位和职位名称'}]">
          <el-input v-model="form3.post" placeholder="请输入单位和职位名称"></el-input>
        </el-form-item>

        <el-form-item label="收入" prop="income" :rules="[{required:true,message:'请输入收入'}]">
          <el-input v-model="form3.income" placeholder="请输入收入"></el-input>
        </el-form-item>

        <el-form-item label="电话" prop="mobile" :rules="[{required:true,message:'请输入电话'}]">
          <el-input v-model="form3.mobile" placeholder="请输入电话"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitDialog('form3');">提交</el-button>
          <el-button @click="dialogVisible3=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 选择申请时间对话框 -->
    <el-dialog title="选择入学时间" :visible.sync="abroadTimeDialog">
      <el-form :model="abroad" :status-icon="true">
        <el-form-item label="年份" prop="year">
          <el-select v-model="abroad.year" placeholder="请选择年份" filterable style="width:100%;">
            <el-option v-for="item in yearList" :label="item+'年'" :value="item" :key="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="月份" prop="month">
          <el-select v-model="abroad.month" placeholder="请选月份" filterable style="width:100%;">
            <el-option v-for="item in [1,4,7,10]" :label="item+'月'" :value="item" :key="item"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="abroadTimeDialog = false;form.abroadDate=abroad.year+'-'+abroad.month;"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
export default {
  data() {
    return {
      key: "",
      state: "",
      query: {}, //对象
      labelWidth: 80,
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      form: {}, //表单对象
      form1: {}, //表单对象
      form2: {}, //表单对象
      form3: {}, //表单对象
      dialogVisible3: false,
      dialogVisible1: false,
      dialogVisible2: false,
      abroadTimeDialog: false,
      yearList: [],
      abroad: {}, //申请时间的对象
      submiting: false,
      id: 0,
      roleVisible: false, //是否显示角色对话框
      treeData: [], //权限树结构
      checkedKeys: [], //选中id列表
      stustatelist: [
        { id: "a", name: "a" },
        { id: "b", name: "b" },
        { id: "c", name: "c" },
        { id: "d", name: "d" },
        { id: "e", name: "e" }
      ], //跟进状态
      purposelist: [
        { id: "升学", name: "升学" },
        { id: "专门学校", name: "专门学校" },
        { id: "就职", name: "就职" },
        { id: "体验文化", name: "体验文化" },
        { id: "未定", name: "未定" }
      ], //赴日目地
      nationlist: [
        { id: "汉族", name: "汉族" },
        { id: "回族", name: "回族" },
        { id: "壮族", name: "壮族" },
        { id: "满族", name: "满族" },
        { id: "藏族", name: "藏族" },
        { id: "朝鲜族", name: "朝鲜族" },
        { id: "其他", name: "其他" },
      ], //赴日目地
      sourselist: [
        { id: "知乎", name: "知乎" },
        { id: "微博", name: "微博" },
        { id: "后台", name: "后台" },
        { id: "公众号", name: "公众号" },
        { id: "B站", name: "B站" },
        { id: "抖音", name: "抖音" },
        { id: "网络搜索", name: "网络搜索" },
        { id: "学生推荐", name: "学生推荐" },
        { id: "合作方推荐", name: "合作方推荐" }
      ], //来源
      edubacklist: [
        { id: "小学", name: "小学" },
        { id: "初中", name: "初中" },
        { id: "中专/高职", name: "中专/高职" },
        { id: "高中", name: "高中" },
        { id: "大专", name: "大专" },
        { id: "本科", name: "本科" },
        { id: "硕士", name: "硕士" },
        { id: "其他", name: "其他" }
      ], //学历
      japlist: url.getJapLevelListForStu(), // 日语水平（统一数据）
      jtestList: [
        { id: "A", name: "A" },
        { id: "B", name: "B" },
        { id: "C", name: "C" },
        { id: "D", name: "D" },
        { id: "E", name: "E" },
        { id: "F", name: "F" },
        { id: "G", name: "G" },
        { id: "无证书", name: "无证书" }
      ], //英语水平
      provincelist: [], //省
      citylist: [], //市
      schoollist: [], //获取学校
      areaList: [], //地区
      selectedOptions: [], //省市县--家庭住址
      selectedOptions2: [] //现住地址
    };
  },
  methods: {
    //市
    selectcity: function() {
      var _this = this;
      var link = url.getCommon("getareabyname");
      $.get(link, { name: _this.form.hjProvinceName }, data => {
        _this.citylist = data;
        _this.form.hjCityName = _this.form.hjCityName || data[0].areaName;
      });
    },
    //省
    province: function() {
      var _this = this;
      var link = url.getCommon("getareabyname");
      $.get(link, {}, data => {
        _this.provincelist = data;
        _this.form.hjProvinceName =
          _this.form.hjProvinceName || data[0].areaName;
        _this.selectcity();
      });
    },
    //获取地区数据
    getArea() {
      var _this = this;
      var link = url.getCommon("getareatwo");
      $.getJSON(link, data => {
        _this.areaList = data;
      });
    },
    // 获取学生信息
    getModel: function() {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.id = _this.id;
      var link = url.getStu("getmodeldetail");
      $.get(link, params, data => {
        _this.loading = false;
        _this.form = data;
        _this.selectedOptions = [data.provinceID, data.cityID, data.countyID];
        if (data.zzProvinceName) {
          _this.selectedOptions2 = [
            data.zzProvinceName,
            data.zzCityName,
            data.zzCountyName
          ];
        }

        if (data.abroadDate) {
          var dateStr = data.abroadDate.substring(0, 7);
          _this.form.abroadDate = dateStr;
          _this.abroad = {
            year: dateStr.split("-")[0],
            month: dateStr.split("-")[1]
          };
        }

        //获取省
        _this.province();
      });
    },
    //获取学校
    school: function() {
      var _this = this;
      var link = url.getCommon("getschool");
      $.get(link, {}, data => {
        _this.schoollist = data;
      });
    },
    //按学校查询
    schoolClick: function() {
      // this.getList();
    },
    goBack: function() {
      this.$router.push({ name: "common" });
    },
    //提交表单
    submitForm(formName) {
      var _this = this;
      var link = url.getStu("update_eval");
      var info = Object.assign({}, this.form);

      //地区处理
      if (this.selectedOptions.length <= 0) {
        _this.$message({
          type: "error",
          message: "请选择家庭地址"
        });
        return;
      }
      info.provinceID = this.selectedOptions[0];
      info.cityID = this.selectedOptions[1];
      info.countyID = this.selectedOptions[2];

      if (this.selectedOptions2.length <= 0) {
        _this.$message({
          type: "error",
          message: "请选择现住地址"
        });
        return;
      }
      info.zzProvinceName = this.selectedOptions2[0];
      info.zzCityName = this.selectedOptions2[1];
      info.zzCountyName = this.selectedOptions2[2];

      //列表数据
      if (info.eduList.length > 0) info.eduList = JSON.stringify(info.eduList);
      if (info.postList.length > 0)
        info.postList = JSON.stringify(info.postList);
      if (info.familyList.length > 0)
        info.familyList = JSON.stringify(info.familyList);

      this.$refs.form.validate(valid => {
        if (valid) {
          this.submiting = true;
          //添加或者修改
          $.post(link, info, res => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.$message({
                type: "success",
                message: res.msg,
                onClose() {
                  _this.goBack();
                }
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //确定学历
    submitDialog(type) {
      var _this = this;
      _this.$refs[type].validate(valid => {
        if (valid) {
          if (type == "form1") {
            adOrUpdate(_this.form1, _this.form.eduList);
            _this.dialogVisible1 = false;
          } else if (type == "form2") {
            adOrUpdate(_this.form2, _this.form.postList);
            _this.dialogVisible2 = false;
          } else {
            adOrUpdate(_this.form3, _this.form.familyList);
            _this.dialogVisible3 = false;
          }
        } else {
          return false;
        }
      });

      function adOrUpdate(data, list) {
        data.stuid = _this.id;
        if (data.id > 0) {
          for (var i = 0; i < list.length; i++) {
            var item = list[i];
            if (item.id == data.id) {
              for (const key in item) {
                if (data.hasOwnProperty(key)) {
                  item[key] = data[key];
                }
              }
              return;
            }
          }
        } else {
          data.id = list.length + 1;
          list.push(data);
        }
      }
    },
    //编辑
    editClick: function(type, row) {
      if (type == "form1") {
        this.form1 = Object.assign({}, row);
        this.dialogVisible1 = true;
      } else if (type == "form2") {
        this.form2 = Object.assign({}, row);
        this.dialogVisible2 = true;
      } else {
        this.form3 = Object.assign({}, row);
        this.dialogVisible3 = true;
      }
    },
    //删除
    delClick: function(type, row) {
      var _this = this;
      if (type == "form1") {
        removeByList(row.id, _this.form.eduList);
      } else if (type == "form2") {
        removeByList(row.id, _this.form.postList);
      } else {
        removeByList(row.id, _this.form.familyList);
      }

      function removeByList(id, list) {
        for (var i = 0; i < list.length; i++) {
          var item = list[i];
          if (item.id == id) {
            list = list.splice(i, 1);
            return;
          }
        }
      }
    }
  },
  mounted() {
    var _this = this;
    //年份
    var yearList = [];
    var year = new Date().getFullYear();
    for (var i = -2; i < 5; i++) {
      yearList.push(year + i);
    }
    this.yearList = yearList;

    //接收参数id
    _this.id = this.$route.query.id;
    _this.getModel();

    //获取学校
    _this.school();
    //获取家庭住址
    this.getArea();
  }
};
</script>

<style>
.clear {
  clear: both;
}
.stuinfo {
  padding: 0px 20px;
  padding-bottom: 20px;
}

</style>
